import { html, KompisElement, property, unsafeHTML } from '@inter-ikea-kompis/web-component';
import {
	EnergyAIcon,
	EnergyApIcon,
	EnergyAppIcon,
	EnergyApppIcon,
	EnergyBIcon,
	EnergyCIcon,
	EnergyDIcon,
	EnergyEIcon
} from '@inter-ikea-kompis/icons';
import type { IProduct, ITheme } from '@inter-ikea-kompis/types';
import { EnergyClassParser } from '@inter-ikea-kompis/utilities';
import type { RenderResult } from '@inter-ikea-kompis/web-component';

const EnergyClassIcon = Object.freeze({
	'A+++': EnergyApppIcon,
	'A++': EnergyAppIcon,
	'A+': EnergyApIcon,
	A: EnergyAIcon,
	B: EnergyBIcon,
	C: EnergyCIcon,
	D: EnergyDIcon,
	E: EnergyEIcon
});

const EnergyClassColor = Object.freeze({
	'A+++': '#00a651',
	'A++': '#50b848',
	'A+': '#bfd730',
	A: '#fff200',
	B: '#fdb913',
	C: '#f37021',
	D: '#ed1c24',
	E: '#ed1c24'
});

/**
 * This component will only exist for a certain time.
 */

export default class EnergyEfficiencyNonRescaled extends KompisElement {
	// A product.
	@property({ type: Object, required: true })
	public product!: IProduct;

	// Theme.
	@property({ type: Object, required: true })
	public theme!: ITheme;

	/**
	 * @returns Template.
	 */
	public override render(): RenderResult {
		const energyClass = EnergyClassParser.parseProduct(this.product);
		if (!energyClass) {
			return null;
		}

		const icon = EnergyClassIcon[energyClass];
		return html`
			<style>
				:host {
					display: flex;
					cursor: pointer;
					outline: none;
				}
				:host:before {
					content: '';
					width: ${this.theme.spacing.space50 / 16}rem;
				}
				svg {
					color: ${EnergyClassColor[energyClass]};
					width: 2.4em;
					height: 100%;
					flex-shrink: 0;
				}
			</style>
			${unsafeHTML(icon)}
		`;
	}
}

declare global {
	interface HTMLElementTagNameMap {
		'kompis-energy-efficiency-non-rescaled': EnergyEfficiencyNonRescaled;
	}
}
